import { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import appActions from 'App/duck/actions'
import appSelectors from 'App/duck/selectors'
import userMenuActions from 'features/account/user-menu/duck/actions'

const getFeatureToggleFlags = (data, setIsLoading, dispatch): any => {
  setIsLoading(true)
  dispatch(appActions.fetchToggleFlagsStart())

  try {
    dispatch(appActions.fetchToggleFlagsSuccess(data))
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
    dispatch(userMenuActions.addDigitalStylistQuiz(data))
  } catch (error) {
    dispatch(appActions.fetchToggleFlagsFail(error))
  } finally {
    setIsLoading(false)
  }
}

const useGetFeatureToggleFlags = (shouldFetchFeatureToggleFlags): any => {
  const dispatch = useDispatch()
  const data = { isDigitalStylistEnabled: useSelector(appSelectors.getIsDigitalStylistEnabled) }
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (shouldFetchFeatureToggleFlags) {
      getFeatureToggleFlags(data, setIsLoading, dispatch)
    }
  }, [shouldFetchFeatureToggleFlags])

  return { isLoading }
}

export default useGetFeatureToggleFlags
